// @ref https://surveyjs.io/survey-creator/examples/add-custom-property-editor/reactjs

import { useDidMount } from "hooks";
import * as SurveyAnalyticsTabulator from "survey-analytics/survey.analytics.tabulator";
import { CustomWidgetCollection, Serializer } from "survey-core";
import * as SurveyCore from "survey-core";
import {
  PropertyGridEditorCollection,
  SurveyQuestionEditorDefinition,
} from "survey-creator-core";
import * as widgets from "surveyjs-widgets";
import * as XLSX from "xlsx";

widgets.ckeditor(SurveyCore);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).XLSX = XLSX;
Serializer.addProperty("survey", {
  name: "pdfOrientation",
  category: "PDF",
  categoryIndex: 10,
  default: "auto",
  choices: ["auto", "portrait", "landscape"],
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfFormatType",
  category: "PDF",
  default: "default",
  choices: [
    "custom",
    "default",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "a10",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "b10",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "c10",
    "dl",
    "letter",
    "government-letter",
    "legal",
    "junior-legal",
    "ledger",
    "tabloid",
    "credit-card",
  ],
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfFormatWidth:number",
  category: "PDF",
  default: 210.0,
  dependsOn: "pdfFormatType",
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  visibleIf(obj: any) {
    return obj?.pdfFormatType === "custom";
  },
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfFormatHeight:number",
  category: "PDF",
  default: 297.0,
  dependsOn: "pdfFormatType",
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  visibleIf(obj: any) {
    return obj?.pdfFormatType === "custom";
  },
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfFontSize:number",
  category: "PDF",
  default: 14,
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfFontName:string",
  category: "PDF",
  default: "Roboto",
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfMarginTop:number",
  category: "PDF",
  default: 10.0,
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfMarginBottom:number",
  category: "PDF",
  default: 10.0,
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfMarginLeft:number",
  category: "PDF",
  default: 10.0,
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfMarginRight:number",
  category: "PDF",
  default: 10.0,
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfHtmlRenderAs",
  category: "PDF",
  default: "auto",
  choices: ["auto", "standard", "image"],
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfMatrixRenderAs",
  category: "PDF",
  default: "auto",
  choices: ["auto", "list"],
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfCompress:boolean",
  category: "PDF",
  default: false,
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfMode",
  category: "PDF",
  default: "edit",
  choices: ["edit", "display"],
  isSerializable: false,
});
Serializer.addProperty("survey", {
  name: "pdfFileName:string",
  category: "PDF",
  default: "survey_result.pdf",
  isSerializable: false,
});
Serializer.addProperty("question", {
  name: "pdfIsPageBreak:boolean",
  category: "PDF",
  default: false,
});
SurveyAnalyticsTabulator.Tabulator.haveCommercialLicense = true;
SurveyAnalyticsTabulator.Tabulator.showFilesAsImages = true;
export const SurveyJSInitializer = () => {
  useDidMount(() => {
    const ckEditor =
      CustomWidgetCollection.Instance.getCustomWidgetByName("editor");
    // Hide from toolbox
    ckEditor.showInToolbox = false;
    PropertyGridEditorCollection.register({
      fit(prop: { type: string; name: string }) {
        return prop.name === "description" || prop.type === "html";
      },
      getJSON() {
        return {
          type: "editor",
        };
      },
    });
    const questionDef = SurveyQuestionEditorDefinition.definition.question;
    // Modify Question Editor. Remove title from general and add it as a tab.
    questionDef.tabs?.push({ name: "Title", index: 1 });
    const ind = questionDef.properties?.indexOf("Title");
    if (ind && ind > -1) questionDef.properties?.splice(ind, 1);
  });

  return null;
};
